import { render } from "./ExportInterfaceForm.vue?vue&type=template&id=564e4678&scoped=true&ts=true"
import script from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"
export * from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"

import "./ExportInterfaceForm.vue?vue&type=style&index=0&id=564e4678&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e4678"]])

export default __exports__